module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/core-js/library/modules/_add-to-unscopables.js
// module id = 962
// module chunks = 48 49 50